import styled from "styled-components";
import footerBG from "../../../../assets/images/nft/v2_footer_bg.png";
import banner from "../../../../assets/images/octopuses/bg2.jpg";

const FooterStyleWrapper = styled.footer`
  padding-top: 105px;
  position: relative;

  &::before {
    position: absolute;
    background: url(${banner});
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    content: "";
    height: 76%;
    width: 100%;
    bottom: 0px;
    opacity:0.7;
  }
`;

export default FooterStyleWrapper;
